<template>
  <div v-if="slideShow">
    <el-carousel
      :interval="slideTime"
      type="card"
      height="488px"
      arrow="always"
      indicator-position="none"
      :autoplay="autoplay"
      slidesPerView="auto"
    >
      <el-carousel-item v-for="item in slideList" :key="item.id">
        <div>
          <img :src="item.pc_image" alt class="img" />
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
const slideListUri = "website/index/slideshow/get/all";

export default {
  props: {
    type: Number
  },
  data() {
    return {
      slideList: [],
      slideTime: 4000,
      slideShow: false,
      autoplay: true
    };
  },
  created() {
    this.getSlideList();
    this.initSlideConfig();
  },
  methods: {
    getSlideList() {
      this.$api.get(slideListUri).then(res => {
        this.slideList = res.list;
      });
    },
    initSlideConfig() {
      let config = this.$cache.get("slideConfig");
      if (config) {
        this.slideTime = config.interval_time;

        if (config.catalog.indexOf(this.type) !== -1) {
          this.slideShow = true;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.el-carousel__container {
  .el-carousel__item {
    
    div {
      height: 100%;
      .img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .is-active {
    width: 1200px !important;
    height: 488px !important;
    position: relative;
    left: 50%;
    transform: translateX(-50%) !important;
    .img {
      width: 1200px !important;
      height: 488px !important;
    }
  }
}
</style>
